import React from "react";
// import poster from "../assets/images/poster.JPG";

function Poster({ poster }) {
  return (
    <div className="w-full h-full">
      <img className="w-full h-full object-cover" src={poster} alt="" />
    </div>
  );
}

export default Poster;
